import { environment } from '../../../environments/environment';

const claimRoute = environment.claimsRoute;

export default claimRoute;
